import * as React from "react";
import './index.css';
import '@caos/cai-toolkit/styles.css';
import { useCaiApp, ChatInterface } from "@caos/cai-toolkit";
import { boxAdapter } from "./boxAdapter";

const App: React.FC = () => {
    const { ready, error, chatInterfaceProps } = useCaiApp({ adapter: boxAdapter });

    if (error) {
        return (
            <div className="min-h-screen flex items-center justify-center text-red-600 text-sm px-4">
                Failed to initialize: {error}
            </div>
        );
    }

    if (!ready) {
        return (
            <div className="min-h-screen flex items-center justify-center text-slate-500 text-sm">
                Loading...
            </div>
        );
    }

    return <ChatInterface {...chatInterfaceProps} />;
};

export default App;
